
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faBriefcase } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, ListItemIcon, ListItemText } from '@material-ui/core'
import Avatar, { ICON_COLOR } from '@scoir/avatar'

import { getIndustryIcon } from 'common/get-industry-icon'
import { EVENT_TYPES } from 'common/track-event-constants'
import SaveAction from 'components/CareerListItem/save-action'

import LinkListItem from '../../LinkListItem'
import { useClickTracking } from '../use-click-tracking'
import { ICareerOptionProps } from './types'

const ResultComponent = ({ name, cluster, soc, id }: ICareerOptionProps) => {
  const trackClickFn = useClickTracking(EVENT_TYPES.CAREER_CLICK)
  const icon = getIndustryIcon(cluster) || faBriefcase

  return (
    <LinkListItem
      to={`${import.meta.env.BASE_URL}/careers/${soc}`}
      id={id}
      hoverText={`Visit: ${name}`}
      secondaryText={cluster}
      label={name}
      onClick={() => {
        trackClickFn()
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        width="100%"
      >
        <ListItemIcon>
          <Box
            width="100%"
            display="flex"
            alignItems="center"
            ml={-1}
            mr={1}
            justifyContent="center"
          >
            <Avatar
              variant="circular"
              size={'sm'}
              iconColor={ICON_COLOR.info}
              fallbackIcon={
                <FontAwesomeIcon
                  size={'sm'}
                  icon={icon as IconDefinition}
                  data-testid="industry-icon"
                />
              }
            />
          </Box>
        </ListItemIcon>
        <ListItemText
          primary={name}
          secondary={cluster}
        />
        <SaveAction
          name={name}
          soc={soc}
        />
      </Box>
    </LinkListItem>
  )
}

export default ResultComponent
